import { allMethods } from './method';
export function visitOperations(openAPI, visitor) {
    var _a;
    for (const [path, pathItem] of Object.entries((_a = openAPI.paths) !== null && _a !== void 0 ? _a : {})) {
        if (!path.startsWith('/')) {
            continue;
        }
        for (const [method, operation] of Object.entries(pathItem)) {
            if (!allMethods.includes(method)) {
                continue;
            }
            visitor(path, pathItem, method, operation);
        }
    }
}
